module.exports = __webpack_public_path__ + "static/media/terracamiarelogo.435e60f5.png";